import { useMemo } from 'react'
import { ProcessedActivity } from '../../../../../api/models'

export interface ActivityTimingResult {
  startOffsetMs: number
  startOffsetSeconds: number
  durationMs: number
  durationSeconds: number
  endOffsetMs: number
  endOffsetSeconds: number
  isActive: boolean
  elapsedSeconds: number
}

export function computeActivityTiming(processedActivity: ProcessedActivity, currentTimeInSeconds: number, isPlaying: boolean): ActivityTimingResult {
  const { relativeStartTimeMillis, relativeStartTimeSeconds, relativeEndTimeMillis, relativeEndTimeSeconds, durationMillis, durationSeconds } =
    processedActivity

  // True once the user has interacted with playback at all (playing or scrubbed)
  const hasPlaybackStarted = isPlaying || currentTimeInSeconds > 0
  // True while the playback position is inside this activity's chapter window
  const isActive = hasPlaybackStarted && currentTimeInSeconds >= relativeStartTimeSeconds && currentTimeInSeconds < relativeEndTimeSeconds

  // How far into this activity the playback position is, clamped to [0, duration]
  const elapsedSeconds = isActive
    ? Math.max(0, Math.min(currentTimeInSeconds - relativeStartTimeSeconds, durationSeconds))
    : currentTimeInSeconds >= relativeEndTimeSeconds
      ? durationSeconds
      : 0

  return {
    startOffsetMs: relativeStartTimeMillis,
    startOffsetSeconds: relativeStartTimeSeconds,
    durationMs: durationMillis,
    durationSeconds: durationSeconds,
    endOffsetMs: relativeEndTimeMillis,
    endOffsetSeconds: relativeEndTimeSeconds,
    isActive,
    elapsedSeconds
  }
}

// TODO: ActivityTiming result needs to be refactored to only contain isActive and elapsedSeconds
export function useActivityTiming(processedActivity: ProcessedActivity, currentTimeInSeconds: number, isPlaying: boolean): ActivityTimingResult {
  return useMemo(
    () => computeActivityTiming(processedActivity, currentTimeInSeconds, isPlaying),
    [processedActivity, currentTimeInSeconds, isPlaying]
  )
}
